import { BASE_API_URL } from "../constants";
export const customerLogotypeSummaryDtoFields = [{
        name: "preview",
        title: "Logo",
        render: (record) => `<img class='customer-logotype-preview' src='${BASE_API_URL}/customer-logotype-preview/${record.oid}'>`
    }, {
        name: "name",
        title: "Nome",
        render: (record) => record.name
    }, {
        name: "size",
        title: "Dimensione",
        render: (record) => record.size
    }];
